// extracted by mini-css-extract-plugin
module.exports = {"off-grid-D":"D_off-grid-D__dRBSG"};